export default __webpack_public_path__ + "static/media/okta.228b0f95.svg";